// extracted by mini-css-extract-plugin
export var story = "about-module--story--7jkh5";
export var journey = "about-module--journey--p68rC";